<div kalDialogContent
     [kalLoading]="loading">

    <app-user-delegation-picker [formControl]="delegationPickerFormControl">
    </app-user-delegation-picker>

</div>

<div kalDialogFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="saveDelegation()"
                        [disabled]="loading || delegationPickerFormControl?.invalid || isSelectionIdenticalToDialogData"
                        kalTheme="primary">
                Valider
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="close()"
                        [disabled]="loading"
                        kalTheme="secondary">
                Annuler
            </kal-button>

        </div>

    </div>

</div>
